import classNames from 'classnames';
import { TooltipBadge } from '../ResultTypeTooltip/ResultTypeTooltip';
import css from './SearchModeBadge.module.scss';

const VARIANT_CLASS: Record<TooltipBadge['variant'], string> = {
  neutral: css.neutral,
  warning: css.warning,
  error: css.error,
};

/**
 * Shared badge ribbon — used at the top of the desktop tooltip AND
 * at the top of the mobile drawer. Colors match the existing "search
 * mode state" palette (purple for neutral/experimental, orange for
 * warning, red for error).
 *
 * Caller passes a `className` to adjust outer shape (e.g. the
 * tooltip needs rounded-top corners that match the tooltip card;
 * the drawer wants none or its own shape).
 */
export const SearchModeBadge = ({
  badge,
  className,
}: {
  badge: TooltipBadge | null;
  className?: string;
}) => {
  if (!badge) return null;
  return (
    <div className={classNames(css.root, VARIANT_CLASS[badge.variant], className)}>
      {badge.icon}
      <span>{badge.label}</span>
    </div>
  );
};
